import { Component, OnChanges, OnInit } from '@angular/core';
import { ColumnStringDto } from 'webcommon/shared';
import { ApColumnBase } from './ap-column-base';

@Component({
  selector: 'ap-column-string',
  templateUrl: './ap-column-string.component.html',
})
export class ApColumnStringComponent extends ApColumnBase<ColumnStringDto> implements OnInit, OnChanges {
  displayString: string;

  load(): void {
    this.displayString = this.columnInfoDto.FormatCallback
      ? this.columnInfoDto.FormatCallback(this.dataItem)
      : '';
  }
}
